/* global localStorage */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, Checkbox, GuidelinesText, Loader } from '../components';
import { ROUTES } from '../Constants';

const GuidelinesWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const InnerWrapper = styled.div`
  overflow-y: scroll;
  padding: 0px 10px 0px 0px;
  height: 390px;
`;

const LoaderWrapper = styled.div`
  margin-top: 160px;
`;

function Guidelines({ isLoading, history }) {
  const [neverShow, setNeverShow] = useState(false);

  if (isLoading) {
    return (
      <GuidelinesWrapper>
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      </GuidelinesWrapper>
    );
  }

  return (
    <GuidelinesWrapper>
      <Card>
        <InnerWrapper>
          <GuidelinesText withTitle />
        </InnerWrapper>

        <Checkbox
          theme="contained"
          onToggle={() => setNeverShow(!neverShow)}
          checked={neverShow}
          label="Don't show from now on"
        />

        <Button
          onClick={() => {
            if (neverShow) {
              localStorage.setItem('showGuidelinesOnLogin', JSON.stringify(false));
            }

            history.push(ROUTES.HOME);
          }}
        >
          Start making calls
        </Button>
      </Card>
    </GuidelinesWrapper>
  );
}

Guidelines.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  isLoading: PropTypes.bool.isRequired
};

function mapStateToProps({ me, agent }) {
  return {
    isLoading: agent.isLoading || me.isLoading
  };
}

export default connect(mapStateToProps)(withRouter(Guidelines));
